import reportImg from './reportIcon.svg'
import reportSelectedImg from './reportSelectedIcon.svg'

export const reportIcon = reportImg;
export const reportSelectedIcon = reportSelectedImg;